module.exports = __webpack_public_path__ + "static/media/exhibition.1e53d7a6.png";